import React from "react"

import { useTranslation } from "react-i18next"

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import { Grid } from "@mui/material"
import { Tooltip, Typography } from "@synapse-analytics/synapse-ui"

import { getTheme } from "../../hooks/UseTheme"

export type CustomTableHeadersType = {
  title: string
  tooltipText: NonNullable<React.ReactNode>
}

export function CustomTableHeaders(props: Readonly<CustomTableHeadersType>): React.ReactElement {
  const { title, tooltipText } = props
  const theme = getTheme()
  const { t } = useTranslation("tables")

  return (
    <Grid item direction="row" justifyContent="center" alignItems="flex-end" spacing={1}>
      <Tooltip title={tooltipText} placement="top" style={{ cursor: "text" }}>
        <Typography variant="a">
          {title}{" "}
          <InfoOutlinedIcon
            sx={{
              color: theme.palette.base.text[1],
              fontSize: "15px",
              verticalAlign: "middle",
            }}
            aria-label={t("customTableHeader.infoIcon")}
          />
        </Typography>
      </Tooltip>
    </Grid>
  )
}

export function CustomTableHeadersWithInternalTooltip(props: Readonly<CustomTableHeadersType>): React.ReactElement {
  const { title, tooltipText } = props

  return (
    <Grid item direction="row" justifyContent="center" alignItems="flex-end" spacing={1} key={title}>
      <Tooltip title={tooltipText} placement="top">
        <Typography variant="a" tooltipVerticalAlign="middle" tooltipIconSize={16} style={{ width: "max-content" }}>
          {title}
        </Typography>
      </Tooltip>
    </Grid>
  )
}
